module.exports = __webpack_public_path__ + "img/chip.ba9ee01e.png";